import type { UseQueryOptions } from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';
import { objectNotNullV2 } from '@/Utils/FnUtils';
import { apiClientOld } from '@/_config/lib/axios/api-client-old';
import { handleResponseThrowError } from '@/_utils/services';
import { GET_PLACES_BY_NAME } from '../constants';
import type { IPlacesNames } from '../types';

type ParamsProps = {
  placeName?: string;
  cityId?: string;
};

const getPlacesByName = (params: ParamsProps) => {
  const { placeName, cityId } = params || {};

  return apiClientOld
    .get<IPlacesNames[]>('estabelecimentos/name', {
      params: objectNotNullV2({
        placeName,
        municipioId: cityId,
      }),
    })
    .then(response => response.data)
    .catch(handleResponseThrowError());
};

type GetPlacesByNameData = Awaited<ReturnType<typeof getPlacesByName>>;

export const useGetPlacesByName = (
  params: ParamsProps,
  options: Omit<
    UseQueryOptions<
      GetPlacesByNameData,
      unknown,
      GetPlacesByNameData,
      (string | ParamsProps)[]
    >,
    'queryKey' | 'queryFn'
  > = {},
) => {
  return useQuery({
    queryKey: [GET_PLACES_BY_NAME, params],
    queryFn: () => getPlacesByName(params),
    ...options,
  });
};
